// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"0d9cb2c5","111":"ca2ad58a","183":"cc54aaf5","331":"8e043679","592":"def17a3b","790":"c4771955","885":"f5da1ead"}[chunkId] + ".chunk.js";
};